import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled from 'styled-components';
import { theme } from '../theme/theme';
const StyledHrContainer = styled.div`
  margin: ${theme.spaces.x24} 0;
`;
const StyledHr = styled.hr`
  border: none;
  border-top: ${theme.spaces.x1} solid ${theme.colors.gray300};
  box-shadow: none;
  display: block;
  height: ${theme.spaces.x1};
`;
export const HrElement = /*#__PURE__*/ forwardRef(({ className, nodeProps, ...props }, ref)=>{
    const { children } = props;
    return /*#__PURE__*/ _jsxs(StyledHrContainer, {
        ref: ref,
        contentEditable: false,
        children: [
            /*#__PURE__*/ _jsx(StyledHr, {
                ...nodeProps
            }),
            children
        ]
    });
});
